/**
 * TimelineMarkerAtom - Status indicator for timeline events
 * Displays a colored circular marker with an icon
 */

import React from 'react';
import './TimelineMarkerAtom.scss';

export interface TimelineMarkerAtomProps {
  status: 'not_started' | 'active' | 'completed';
  className?: string;
}

const TimelineMarkerAtom: React.FC<TimelineMarkerAtomProps> = ({
  status,
  className = '',
}) => {
  const getStatusIcon = (): string => {
    const iconMap: Record<typeof status, string> = {
      not_started: 'pi-circle',
      active: 'pi-play-circle',
      completed: 'pi-check-circle',
    };
    return iconMap[status] || 'pi-circle';
  };

  const getStatusClass = (): string => {
    const classMap: Record<typeof status, string> = {
      not_started: 'status-not-started',
      active: 'status-active',
      completed: 'status-completed',
    };
    return classMap[status] || 'status-not-started';
  };

  return (
    <div
      className={`timeline-marker-atom ${getStatusClass()} ${className}`}
    >
      <i className={`pi ${getStatusIcon()}`} />
    </div>
  );
};

export default TimelineMarkerAtom;
